const menWish = [
  'Ты необыкновенный мужчина! Таких больше нет!',
  'Никогда еще никто не понимал меня так хорошо, как ты. Мне даже не нужно ничего говорить. Ты и так понимаешь и видишь все по моему взгляду',
  'Линия судьбы на твоей ладошке говорит, что очень удачливый человек',
  'Со своей дальновидностью и рациональностью ты можешь высоко подняться',
  'С тобой моя жизнь превратилась в сказку! Ты Добрый Фей?',
  'Я в тебе не ошиблась! Ты лучший мужчина! Ты мой мужчина!',
  'Меня всегда поражало твое спокойствие. Ты как скала, о которую разбиваются любые жизненные волны!',
  'Твой низкий голос - украшение для такого мужчины, как ты',
  'У тебя определенно непревзойденный талант в этой сфере',
  'Твоя улыбка похожа на очаровательную улыбку маленького херувимчика',
  'Ты заставляешь меня испытывать невероятные позитивные эмоции! Как ты это делаешь?',
  'Галантность и искреннее уважение к слабому полу - вот что выгодно отличает тебя от других!',
];

const womenWish = [
  'Ты как кофе, от тебя возникает зависимость',
  'Твоя красота как вечнозелёное растение',
  'Твоя аура настолько тёплая, что согревает',
  'Твоя душа и твоё сердце чище воды',
  'Ты лучше любого антидепрессанта',
  'Твоё сердце делает меня ближе к небу',
  'С тобой так уютно, что в твоём сердце хочется поселиться',
  'Твоя мудрость может освобождать от оков',
  'Только ты можешь вылечить мою душу',
  'Войдя в мою душу, ты подарила надежду на жизнь',
  'Твой голос как аскетический рай',
  'Твой слова как лестница к звёздам',
  'Ты - свет, сияющим ярко и высоко надо мной',
  'Ты даришь чувство безопасности больше, чем милиция',
  'Загляни в зеркало: там твой спаситель и твой проводник',
  'Только ради искр в твоих глазах стоит жить',
  'Мы безумны, да кого это волнует',
  'Твой голос - искушающий зов сирены',
  'Я помню, как звёзды осыпались с твоих нежных рук',
  'Ты стоишь того, чтобы занять свою собственную сторону',
];

export { menWish, womenWish };
